import {effect, inject, Injectable, signal, WritableSignal} from '@angular/core';
import {SettingsService} from '../services/settings-service';

@Injectable({ providedIn: 'root' })
export class SettingsStore {
	private settingsService = inject(SettingsService)
	readonly darkTheme: WritableSignal<boolean> = signal(false)

	constructor() {
		const settings = JSON.parse(localStorage.getItem('settings') || '{}');
		if (settings !== '{}') this.darkTheme.set(settings.darkTheme);

		effect( () => {
			this.settingsService.update({ darkTheme: this.darkTheme() })

			if (this.darkTheme()) document.documentElement.classList.add('dark-mode-toggle');
			else document.documentElement.classList.remove('dark-mode-toggle');
		})
	}

	setDarkTheme(isDark: boolean) {
		this.darkTheme.set(isDark)
	}
}
